export default "__VITE_ASSET__NvsWLMeZ__"